/*eslint-disable */
import getters from "./getters"
import actions from "./actions"
import mutations from "./mutations"
import cacheLs from "../cacheLs";

const state = {
  chatbotPromptResponse: cacheLs.get_chatbot_prompt_response(),
  lastUpdatedTime: null
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}